export default class AddGroupMembershipItem {
  constructor(groupId) {
    this.GroupId = groupId;
    this.UserIds = [];
  }
}
